module.exports = __webpack_public_path__ + "img/estrada_velha5.6c02d96e.jpg";